import MobileDetect from 'mobile-detect';
import React from 'react';
import { StyleSheet } from 'react-native';
import { MBText } from '@shared/components/text';
import { grid } from '@shared/styles';

const md = new MobileDetect(window.navigator.userAgent);

const Styles = StyleSheet.create({
  emojiSmall: {
    width: 12,
    height: 12,
    fontSize: 12,
    textAlign: 'center',
    lineHeight: 12,
    // The following two styles were required to nudge the emoji into horizontal centre
    position: 'relative',
    left: -1,
  },
  emojiNormal: {
    width: 24,
    height: 24,
    fontSize: 24,
    textAlign: 'center',
    // Note(fant): in emoji-mart they use lineHeight: 1.15
    // but we can't do that because 1.15 => 1.15px
    marginTop: md.match('Windows') ? -12 : -6,
    marginLeft: md.match('Windows') || md.match('Linux') ? -6 : 0,
  },
  emojiLarge: {
    width: grid(4),
    height: grid(4),
    fontSize: grid(4),
    textAlign: 'center',
    marginTop: md.match('Windows') || md.match('Linux') ? -8 : -6,
    marginLeft: md.match('Windows') || md.match('Linux') ? -5 : 0,
  },
});

type EmojiSizes = 'small' | 'normal' | 'large';
interface MBEmojiIconProps {
  emoji: string;
  size?: EmojiSizes;
}
function getEmojiStyle(size: EmojiSizes) {
  if (size === 'small') {
    return Styles.emojiSmall;
  }
  if (size === 'normal') {
    return Styles.emojiNormal;
  }
  if (size === 'large') {
    return Styles.emojiLarge;
  }
}

export function MBEmojiIcon({ emoji, size = 'normal' }: MBEmojiIconProps) {
  return <MBText style={getEmojiStyle(size)}>{emoji}</MBText>;
}
